<div class="PGLanguageSelector" ngbDropdown [autoClose]="true" (openChange)="openChange.emit($event)">
    <button class="btn btn-white" ngbDropdownToggle>
        <i class="fa-regular fa-globe fa-lg"></i>
    </button>
    <div ngbDropdownMenu>
        @for (language of availableLanguages; track language) {
            <button class="PGLanguageSelector-Item dropdown-item {{currentLanguage == language ? 'active' : ''}}" (click)="setLanguage(language)">
                <span>{{getLanguageLabel(language)}}</span>
            </button>
        }
    </div>
</div>